import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { MAIN_CSS_CLASS_NAME } from "./_common/modules/Data/static";
import "./index.scss";

ReactDOM.createRoot(document.getElementById(MAIN_CSS_CLASS_NAME) as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
